import { Controller } from "@hotwired/stimulus"

// Generic loading indicator for links.
// Applies a loading class to a target element on click,
// guarantees a minimum display time, then follows the link.
//
// data-controller="loading"
// data-action="click->loading#start"
// data-loading-min-value="600"
// data-loading-target="indicator"

export default class extends Controller {
  static targets = ["indicator"]
  static values = {
    min: { type: Number, default: 600 }
  }

  start(event) {
    if (this.running) return

    event.preventDefault()
    this.running = true
    this.indicatorTarget.classList.add("is-spinning")

    setTimeout(() => {
      this.element.removeAttribute("data-action")
      this.element.click()
    }, this.minValue)
  }
}
